<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['group-button', getSelectedDEV && 'dev-selected-component']"
  >
    <template v-for="(item, index) in filteredItems">
      <v-tooltip bottom :color="item.tooltipColorClass" :disabled="!item.tooltip" :key="generateId(item.id + '_' + index)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :data-has-tooltip="item.tooltip || item.label ? 'true' : 'false'"
            :data-tooltip="item.tooltip || item.label"
            v-on="on"
            v-bind="[item.attributes, attrs]"
            :disabled="item.readonly"
            :name="item.name"
            :id="generateId(item.id)"
            @click="execute(item)"
          >
            <v-icon
              v-if="item.attributesIcon.icon && !item.attributesIcon.right"
              v-bind="item.attributesIcon"
              class="mr-1"
              >{{ item.attributesIcon.icon }}</v-icon
            >
            {{ item.label }}
            <v-icon
              v-if="item.attributesIcon.icon && item.attributesIcon.right"
              v-bind="item.attributesIcon"
              class="ml-1"
              >{{ item.attributesIcon.icon }}</v-icon
            >
          </v-btn>
        </template>
        <span>{{ item.tooltip }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import * as HANDLERS from '@/helpers/types/handlers';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, inputEventsMixin, componentMixin],

  data: () => ({
    actionName: '',
    filteredItems: []
  }),

  mounted() {
    this.filteredItems = this.schema.items.filter(item => item.visible);
  },

  watch: {
    schema: {
      handler(newValue, oldValue) {
        this.filteredItems = this.schema.items.filter(item => item.visible);
      },
      deep: true
    }
  },

  events: {
    [HANDLERS.HIDE_ACTION]: 'hideAction',
    [HANDLERS.SHOW_ACTIONS]: 'showAllActions'
  },

  methods: {
    hideAction({ action, mode, page }) {
      if (this.formOptions.mode !== mode || this.formOptions.page !== page || !this.filteredItems) return;

      let element = this.schema.items.find(a => a.name === action);

      if (element) element.visible = false;
    },

    showAllActions({ mode, page }) {
      if (this.formOptions.mode !== mode || this.formOptions.page !== page || !this.filteredItems) return;

      for (let action of this.schema.items) {
        if ('hidden' in action) return;
        action.visible = true;
      }
    },
    
    execute(action) {
      action.mode = this.formOptions.mode;

      this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.formOptions.page });
    }
  }
};
</script>

<style lang="scss" scoped>
.group-button {
  button {
    margin-right: 10px;

    &:last-child {
      margin-right: 0px;
    }
  }
}
</style>
